import Api from "./Api";

export default {
    subscribe(form) {
        return Api.post("/marketing/newsletter", form);
    },
}